import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem } from "@material-ui/core";
import t from "../../languages/pl";
import CancelAcceptForm from './CancelAcceptForm';
import { indefinitePasswordExpiration } from "../../utils/staticData";

const styles = makeStyles({
    content: {
        display: "flex",
        justifyContent: "center"
    }
});

const ChangePasswordExpirationDialog = props => {
    const { open, onClose, onSubmit } = props;
    const classes = styles();
    const [value, setValue] = useState(30);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>
                {t.changePasswordExpiration}
            </DialogTitle>
            <DialogContent className={classes.content}>
                <TextField
                    label={t.passwordExpiration}
                    style={{width: 200}}
                    select
                    name="expiration"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                >
                    <MenuItem value={30}>30&nbsp;{t.days}</MenuItem>
                    <MenuItem value={60}>60&nbsp;{t.days}</MenuItem>
                    <MenuItem value={90}>90&nbsp;{t.days}</MenuItem>
                    <MenuItem value={indefinitePasswordExpiration}>{t.noExpiration}</MenuItem>
                </TextField>
            </DialogContent>
            <DialogActions>
                <CancelAcceptForm
                    onCancel={onClose}
                    onSubmit={() => onSubmit && onSubmit(value)}
                />
            </DialogActions>
        </Dialog>
    );
};

ChangePasswordExpirationDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func
};

export default ChangePasswordExpirationDialog;
